import { ChevronLeftIcon } from "@heroicons/react/20/solid";
import { SectionTitle } from "@packages/core-client/components/SectionTitle.tsx";
import { Button } from "@/components/ui/button.tsx";

export interface FilterPanelHeaderProps {
    title: string;
    onBack?: () => void;
    backLabel?: string;
}

export function FilterPanelHeader({ title, onBack, backLabel }: FilterPanelHeaderProps) {
    if (!onBack) {
        return <SectionTitle>{title}</SectionTitle>;
    }

    return (
        <div className="flex items-center gap-1">
            <Button intent="plain" size="sq-xs" aria-label={backLabel} onPress={onBack}>
                <ChevronLeftIcon aria-hidden="true" />
            </Button>
            <SectionTitle>{title}</SectionTitle>
        </div>
    );
}
